RivalIQ.apps.Admin.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmptyResults = Marionette.ItemView.extend({
        template: '#adminEmptyResultsTemplate',
        emptyMessage: null,

        templateHelpers: function () {
            const me = this;
            return {
                message: me.getOption('emptyMessage')
            };
        }
    });
});
